import React from "react";

const App = () => {
  return <div className="App">xabalu</div>;
};

export default App;
